import Pagination from '../modules/pagination.js'
import PerPage from '../modules/perPage.js'
import productCardSwiper from '../modules/productSwiper.js'

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('pagination')

    new Pagination(container, {
        totalPages: 20,
        currentPage: 1,
        onPageChange: function (page) {
            console.log('Переход на страницу:', page)
        },
    })

    const perPageContainer = document.querySelector('.per-page')
    new PerPage(perPageContainer, {
        title: 'Выводить по',
        perPage: ['24', '48', '96'],
        onPerPageChange: function (perPage) {
            console.log('Выбрано:', perPage)
        },
    })

    const filters = document.querySelector('.catalog__filter-content')
    const filterBtn = document.getElementById('filter-btn')

    if (filterBtn) {
        filterBtn.addEventListener('click', () => {
            filterBtn.classList.toggle('catalog__filter-btn--active')
            filters.classList.toggle('catalog__filter-content--active')
        })
    }

    const secondaryBtns = document.querySelectorAll('.catalog__filter-secondary-btn')

    secondaryBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            filterBtn.textContent = `Цена ${btn.textContent.toLocaleLowerCase()}`
            filters.classList.remove('catalog__filter-content--active')
            filterBtn.classList.remove('catalog__filter-btn--active')
        })
    })

    const listHeaderItem = document.querySelectorAll('.catalog-sidebar__list-header-wrapper')

    listHeaderItem.forEach((listItem) => {
        listItem.addEventListener('click', () => {
            const listContent = listItem.nextElementSibling
            const listSelectedItems = listContent.nextElementSibling

            // Открываем/закрываем контент
            listContent.classList.toggle('catalog-sidebar__list-content--active')

            // Проверяем, есть ли блок с выбранными элементами (не у всех категорий он есть)
            if (listSelectedItems && listSelectedItems.classList.contains('catalog-sidebar__selected-items')) {
                listSelectedItems.classList.toggle('catalog-sidebar__selected-items--active')
            }

            // Анимируем крестик, если он есть
            const crossSvg = listItem.querySelector('.catalog-sidebar__cross-svg-wrapper')
            if (crossSvg) {
                crossSvg.classList.toggle('catalog-sidebar__cross-svg-wrapper--active')
            }
        })
    })

    const selectedItems = {
        type: [],
        probe: [],
        material: [],
        collection: [],
    }

    const allCheckboxes = document.querySelectorAll('input[type="checkbox"]')

    allCheckboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
            const spanValue = checkbox.nextElementSibling
            const checkboxValue = spanValue.textContent
            const listName = checkbox.dataset.list || 'unnamed'
            if (!checkbox.checked) {
                selectedItems[listName] = selectedItems[listName].filter((item) => item !== checkboxValue)
            } else {
                selectedItems[listName].push(checkboxValue)
            }
            updateSelectedItems(selectedItems[listName], listName)
        })
    })

    function updateSelectedItems(menuItems, listName) {
        const selectedItemsWrapper = document.querySelector(`#selected-${listName}`)
        selectedItemsWrapper.innerHTML = ''
        menuItems.forEach((menuItem) => {
            const selectedItemsWrapper = document.querySelector(`#selected-${listName}`)
            const newItem = document.createElement('span')
            newItem.classList.add('catalog-sidebar__selected-item')
            newItem.textContent = menuItem
            selectedItemsWrapper.appendChild(newItem)
        })
    }
})
